import React from "react";
import Link from "gatsby-link";
import Circle from "./circle.svg";
import { Wrapper } from "./style";

const Logo = () => (
  <Wrapper>
    <div>
      <Link to="/">
        <div className="logo">
          <span className="spaced">N</span>
          <span className="spaced">a</span>
          <span className="spaced">u</span>
          <span className="spaced">s</span>
          <span className="spaced">i</span>
          <span className="spaced">c</span>
          <span className="spaced">a</span>
          <span className="spaced">ä</span>
        </div>
      </Link>
    </div>
  </Wrapper>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/index.js